"use client";

import React from "react";
import type { ConfigItemT } from "@/forApp/types/Config";
import styles from "./styles.module.css";

interface ContactsCardProps {
	card: ConfigItemT;
}

export default function ContactsCard({ card }: ContactsCardProps) {
	const getTitle = (code: string) => {
		if (code.includes("hot")) {
			return "Горячая линия";
		} else if (code.includes("coop")) {
			return "Сотрудничество";
		}
		return card.title;
	};

	const getLinkHref = (code: string, value: string | null) => {
		if (!value) return undefined;

		if (code.includes("phone")) {
			return `tel:${value.replace(/\s+/g, "")}`;
		} else if (code.includes("email")) {
			return `mailto:${value}`;
		}
		return undefined;
	};

	const href = getLinkHref(card.code, card.value);

	return (
		<>
			{href ? (
				<a href={href} className={`${styles.card} ${styles.cardLink}`}>
					<div className={styles.content}>
						<h3 className={styles.title}>{getTitle(card.code)}</h3>
						<p className={styles.value}>{card.value || ""}</p>
					</div>
				</a>
			) : (
				<div className={styles.card}>
					<div className={styles.content}>
						<h3 className={styles.title}>{getTitle(card.code)}</h3>
						<p className={styles.value}>{card.value || ""}</p>
					</div>
				</div>
			)}
		</>
	);
}
